import { ObjectId } from 'lib_ui-services';
import { SAVED_FILTER_TITLE_PREFIX } from './serializedEachImportConstants';

/**
 * Serialized Each — build the personal `application:savedFilter` record for a completed import.
 *
 * Pure construction, mirroring the shape a manual "save filter" produces (SearchPaneHeader displayPopup):
 * a personal filter (`isShared:false`, `identity:user` set) with a `routePath` bound to the report page
 * and `filters` keyed by the report's Import search-element id. Deliberately omits the server
 * placeholder's `criteria` field — the client consumes `filters`, not raw mongo criteria (WORKING-DOC §1d/§5).
 *
 * @param {Object} params
 * @param {string} params.importName the import title (`result.title`) — drives the filter title + value.
 * @param {Object} [params.briefUserReference] `{ _id, displayName }` of the importing user (owns the personal filter).
 * @param {string} params.routePath the resolved item-report route (e.g. `/g/0/Reports/Assets`).
 * @param {string} params.importElementId hNode id of the report's hidden Import search element.
 * @returns {Object} an `application:savedFilter` record.
 */
export default function buildImportSavedFilter({ importName, briefUserReference, routePath, importElementId }) {
    return {
        _id: ObjectId(),
        title: `${SAVED_FILTER_TITLE_PREFIX}${importName}`,
        namespace: 'item',
        relation: 'item',
        // Personal: isShared:true would redirect to application:sharedFilter (willCreate_application_savedFilter).
        isShared: false,
        'identity:user': briefUserReference,
        routePath,
        // The hydrate/load path keys filter state by search-element id; the Import element filters on meta.import.
        filters: { [importElementId]: importName }
    };
}
